import React from 'react';
import { Zap, MapPin, Activity, Database, Shield, Code } from 'lucide-react';
import { features } from '../mock';

const iconMap = { Zap, MapPin, Activity, Database, Shield, Code };

export const Features = () => {
  return (
    <section id="features" className="py-16 md:py-32 bg-[#111827] relative overflow-hidden">
      <div className="absolute inset-0 pro-grid opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="inline-block mb-3 md:mb-4">
            <span className="text-green-400 text-[10px] md:text-xs font-semibold uppercase tracking-wider">Platform Features</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 px-4">
            Everything You Need to <span className="text-green-400">Scale</span>
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto px-4">
            Production-ready infrastructure with developer-friendly tools
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group"
                style={{ animation: 'fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards', animationDelay: `${index * 100}ms`, opacity: 0 }}
              >
                <div className="glass-card rounded-xl md:rounded-2xl overflow-hidden h-full hover:border-green-500/20 transition-all duration-300">
                  {feature.image && (
                    <div className="h-40 md:h-48 overflow-hidden relative">
                      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E14] via-[#0A0E14]/60 to-transparent z-10"></div>
                      <img
                        src={feature.image}
                        alt={feature.title}
                        className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                        style={{ filter: 'brightness(0.7) saturate(0.9)' }}
                      />
                    </div>
                  )}
                  
                  <div className="p-5 md:p-8">
                    <div className="w-10 h-10 md:w-12 md:h-12 mb-4 md:mb-5 bg-green-500/10 rounded-lg flex items-center justify-center group-hover:bg-green-500/15 transition-colors duration-300">
                      <Icon className="text-green-400" size={20} />
                    </div>
                    
                    <h3 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3 group-hover:text-green-400 transition-colors duration-300">
                      {feature.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed text-sm">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};